import { CircularProgress, FormControlLabel } from '@mui/material';
import 'js/components/data_sources/add_ds_form/SelectBucket.scss';
import { PROBE_GET_TREE_REQUEST } from 'js/constants/actionTypes';
import { isEmpty } from 'lodash';
import { Database } from 'new/elements/flows/Databases/components/Database';
import useDatabases, {
  DatabasesProps,
  DatabasesProvider,
} from 'new/elements/flows/Databases/useDatabases';
import { Stack } from 'new/elements/Stack';
import { Switch } from 'new/elements/Switch';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import usePaging from 'new/state/paging/repository/usePaging';
import useProbe from 'new/state/probe/repository/useProbe';
import React, { memo } from 'react';
import classes from './Databases.module.scss';

const Stream = ({ databases }) => {
  const { onChangeSyncAll, selection } = useDatabases();

  return (
    <Stack direction="row" alignItems="center" gap="16px" marginLeft="20px">
      <FormControlLabel
        control={<Switch onChange={onChangeSyncAll} color="primary" />}
        checked={!selection.__selectionCount__}
        label="Sync all"
        labelPlacement="end"
      />
    </Stack>
  );
};

export const Databases = memo<DatabasesProps>((props: DatabasesProps) => {
  const { sourceConnector, credentialId, isDestination } = props;
  const { getProbeData } = useProbe();
  const { getMetaInfoById } = usePaging();
  const probe = getProbeData(credentialId);
  const meta = getMetaInfoById(sourceConnector);
  const isLoading = useIsLoading(PROBE_GET_TREE_REQUEST) && isEmpty(probe.data);

  if (isLoading) {
    return (
      <div className="select-bucket-tree-list-loading">
        <CircularProgress />
        Fetching streams from {meta?.displayName} source...
      </div>
    );
  }

  return (
    <DatabasesProvider {...props}>
      <div className={classes.databases}>
        {props.isDestination && props.needsSelection ? (
          <Stream databases={props.databases} />
        ) : null}
        <ul>
          {props.databases.map((database) => {
            return (
              <Database
                key={database.id}
                needsSelection={props.needsSelection}
                database={database}
                isCDCMode={props.isCDCMode}
              />
            );
          })}
        </ul>
      </div>
    </DatabasesProvider>
  );
});
